// extracted by mini-css-extract-plugin
export default {"sbl":"RippleSpinner_sbl__HNWDu","rotate":"RippleSpinner_rotate__L1D11"};